module.exports = __webpack_public_path__ + "img/italy-cerebrovascular-disease-male.176448c7.png";